<template>
  <modal ref="modal" @close="onClose">
    <template slot="title">Export EngageCros</template>
    <template slot="name">EngageCrosにエクスポート（今月残り {{ limitedRemainingCount }}/{{ maxCount }}）</template>
    <template slot="submit">
      <button v-if="limitedRemainingCount > 0 && !isLoading" type="button" @click="onSubmit" class="submit normal-btn">送信</button>
      <button v-else type="button" disabled class="submit normal-btn">送信</button>
    </template>
  </modal>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import modal from '@/components/Util/Modal'

export default {
  name: 'export-ec-v1',
  mixins: [ base ],
  data () {
    return {
      rawHTML: '',
      mobileCSS: '',
      email: '',
      maxCount: 0,
      currentCount: 0,
      isLoading: false,
    }
  },
  components: {
    modal
  },
  created () {
    this.initRateLimit()
  },
  methods: {
    async initRateLimit () {
      await this.$http({
        url: '/plan/rate_limit',
        type: 'GET',
      }).then((json) => {
        this.maxCount = json.data.plan.ec_v1_and_zip_export_max_count
        this.currentCount = json.data.using.ec_v1_and_zip_export_max_count
      })
    },
    onClose () {
      this.$emit('close')
    },
    async onSubmit () {
      this.isLoading = true
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      const randContentId = this.$utils.string.generateRandContentId()
      const sections = await this.getReplacedUrlSections(randContentId, 'ec_v1')
      if (!sections) return

      this.createRawHTML(sections)
      await this.getContentSize()
      const saveJson = await this.$store.dispatch('savePreviewData')
      if (!saveJson || saveJson.status !== 200) return

      // ECへエクスポートするHTMLメール
      this.createRawHTML(sections)
      this.mobileCSS = this.createMobileCSS()
      const formData = new FormData()
      formData.append('body', this.rawHTML)
      formData.append('contentId', this.$route.params.id)
      formData.append('randContentId', randContentId)
      // title
      formData.append('title', this.$store.getters.getContentInfo.name)
      // モバイルスタイルCSS
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())
      await this.$http({
        type: 'POST',
        url: '/ec_v1_content/save_draft',
        params: formData,
      })
      this.$emit('close')
    },
  },
  computed: {
    limitedRemainingCount () {
      const remainingCount = this.maxCount - this.currentCount
      return remainingCount <= 0 ? 0 : remainingCount
    }
  },
}
</script>

<style lang="scss" scoped>
.submit {
  font-size: 14px;
  border-radius: 5px;
  color: #fff;
  border: solid 1px #484848;
  background: #484848;
  &:hover {
    background: #484848;
    opacity: 0.8;
  }
  &:disabled {
    border: solid 1px #6c757d;
    background: #6c757d;
    opacity: 0.8;
    cursor: default;
  }
}
</style>
